export default [
  {
    label: '-',
    value: 0,
  },
  {
    label: 'Zクラス',
    value: 1,
  },
  {
    label: 'Bクラス',
    value: 2,
  },
  {
    label: 'Cクラス',
    value: 3,
  },
  {
    label: '体験中',
    value: 4,
  },
  {
    label: 'PRO',
    value: 5,
  },
  {
    label: 'イベント',
    value: 6,
  },
  {
    label: '休眠',
    value: 7,
  },
  {
    label: 'ここってなんもじはいるんだったっけ？',
    value: 8,
  },
]
